module.exports = __webpack_public_path__ + "img/picks.25335b27.svg";